import { normalizarTexto } from "../../../utilities/textValidations.js";

export const validarCamposSubproducto = ({ descripcion, tipo, metraje }) => {
  if (!descripcion || !tipo || metraje === null || metraje === undefined) {
    return "Descripción, Tipo y Metraje son obligatorios.";
  }
  return null;
};

export const existeSubproductoDuplicado = (subproductos, descripcion, idExcluido = null) => {
  const desc = normalizarTexto(descripcion);
  return (subproductos || []).some(
    (s) => normalizarTexto(s.descripcion) === desc && s.id !== idExcluido
  );
};

export const esFichaJsonValida = (ficha) => {
  if (!ficha) return true;
  try {
    JSON.parse(ficha);
    return true;
  } catch (e) {
    return false;
  }
};
